<template src="./template.html"></template>

<script>
import GliderJs from 'glider-js/glider'
import 'glider-js/glider.css'

export default {
  name: 'glider-carousel',
  props: {
    options: {
      default: () => {
        return {
          type: Object,
          default: {},
        }
      },
    },
    itemSelector: {
      type: String,
    },
    itemWidth: {
      default: 'auto',
    },
    arrows: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      glider: null,
      currentSlide: 0,
    }
  },
  methods: {
    _enableAutoPlay() {
      const autoplayDelay = 3500

      const autoplayFn = () => {
        this._glider.scrollItem('next')
      }

      let autoplay = setInterval(() => {
        autoplayFn()
      }, autoplayDelay)

      this.$refs.gliderCarouselEl.addEventListener(
        'mouseover',
        () => {
          if (autoplay != null) {
            clearInterval(autoplay)

            autoplay = null
          }
        },
        300
      )

      this.$refs.gliderCarouselEl.addEventListener(
        'mouseout',
        () => {
          if (autoplay == null) {
            autoplay = setInterval(() => {
              autoplayFn()
            }, autoplayDelay)
          }
        },
        300
      )
    },
  },
  mounted() {
    const options = Object.assign({}, this.options, {
      itemWidth: this.itemWidth,
      arrows: this.arrows
        ? {
            prev: this.$refs.gliderPrevEl,
            next: this.$refs.gliderNextEl,
          }
        : undefined,
    })

    this._glider = new GliderJs(this.$refs.gliderCarouselEl, options)

    if (this.autoplay) {
      this._enableAutoPlay()
    }

    if (this.itemSelector) {
      this.$refs.gliderEl.querySelectorAll(this.itemSelector).forEach((el) => {
        el.addEventListener('click', (e) => {
          this.$emit('item-clicked', e.currentTarget)
        })
      })
    }
  },
  destroyed() {
    if (this._glider) {
      this._glider.destroy()
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/GliderCarousel/index.vue